<h2 mat-dialog-title class="m-0">User Preferences</h2>
<form [formGroup]="userPreferencesForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content>
        <mat-tab-group>
            <mat-tab label="Pin Size">
                <div class="center-slider">
                    <mat-slider
                            class="slider-formatting"
                            [max]="100"
                            [min]="10"
                            [step]="10"
                            [discrete]="true"
                            [showTickMarks]="true"
                            [displayWith]="formatLabel"
                            color="primary"
                            aria-labelledby="Pin_Slider">
                        <input
                                matSliderThumb
                                [value]="50"
                                (valueChange)="calculatePinSize($event)">
                    </mat-slider>
                </div>

                <div id="mapPref" style="min-height: 500px;"></div>
            </mat-tab>

            <mat-tab label="Communications">
                <div class="p-3 d-grid gap-3">
                    <mat-slide-toggle color="primary" formControlName="marketing_consent" [disabled]="marketingConsentUpdating" (change)="updateMarketingConsent($event)">Marketing communications</mat-slide-toggle>
                    <p class="mb-0">Receive product updates, news, and offers from Fire Survey Pro by email. This preference saves immediately and can be changed at any time.</p>
                </div>
            </mat-tab>

            <mat-tab label="Signature">
                <div class="signature-settings p-3">
                    <p>Save a signature for protected Site sign-off. Your saved image is private and you will confirm it before each sign-off.</p>

                    @if (signatureLoading) {
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    } @else {
                        @if (signature?.preview_url || signaturePreview) {
                            <div class="signature-preview">
                                <img [src]="signaturePreview || signature?.preview_url" alt="Signature preview" />
                            </div>
                        }

                        @if (signature && !signaturePreview) {
                            <p class="mb-2"><strong>Current signature</strong> · {{ signature.width }}×{{ signature.height }} px</p>
                        } @else if (!signaturePreview) {
                            <p class="mb-2">No signature saved.</p>
                        }

                        <input #signatureInput hidden type="file" accept="image/png,image/jpeg,image/webp" (change)="selectSignature($event)" />
                        <div class="signature-actions">
                            <button mat-stroked-button type="button" (click)="signatureInput.click()" [disabled]="signatureSaving">{{ signature ? 'Replace' : 'Choose image' }}</button>
                            @if (signaturePreview) {
                                <button mat-raised-button color="primary" type="button" (click)="saveSignature()" [disabled]="signatureSaving">Save signature</button>
                            }
                            @if (signature) {
                                <button mat-stroked-button color="warn" type="button" (click)="removeSignature()" [disabled]="signatureSaving">Remove</button>
                            }
                        </div>
                    }

                    @if (signatureError) {
                        <p class="signature-error" role="alert">{{ signatureError }}</p>
                    }
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div mat-dialog-actions>
        <div class="col-12">
            <button mat-stroked-button mat-dialog-close>Cancel</button>
            <button type="submit" class="float-end" mat-raised-button color="primary" cdkFocusInitial>Save Preferences</button>
        </div>
    </div>
</form>
